// Estilos globales de la aplicación
import './styles/index.css';

// Servicios y enrutador
import { authService } from './services/auth.service';
import { router } from './router/router';
import { routes } from './router/routes';
import { $ } from './utils/dom';

import { getTyrisIcon } from './components/ui/tyris-icon';

async function bootstrap() {
  const container = $('#app');
  if (!container) {
    console.error('No se encontró el elemento contenedor #app');
    return;
  }

  // 1. Configurar enrutador con el contenedor de montaje y rutas
  router.setContainer(container).register(routes);

  // 2. Intentar validar sesión persistente si hay un token guardado
  if (authService.getToken()) {
    container.innerHTML = `
      <div style="min-height: 100vh; display: flex; align-items: center; justify-content: center; background-color: var(--bg-base); flex-direction: column; gap: 1rem;">
        <div style="color: var(--tyris-iris); animation: spin 1s linear infinite;">${getTyrisIcon('en-curso', { size: 36 })}</div>
        <div style="font-weight: 600; color: var(--text-muted);">Sincronizando perfil...</div>
      </div>
      <style>
        @keyframes spin { 100% { transform: rotate(360deg); } }
      </style>
    `;
    await authService.fetchMe();
  }

  // 3. Resolver la ruta inicial basada en el Hash actual
  await router.resolveRoute();
}

// Arrancar la aplicación
bootstrap().catch(console.error);
